import React, { useEffect, useMemo, useRef, useState } from 'react';

import { create } from './player';
import { PlayerOverlay } from './playerOverlay';

interface RegionVideoWixProps {
  url: string;
  previewImageAltText?: string;
}

export function RegionVideoWix(props: RegionVideoWixProps) {
  const { url, previewImageAltText } = props;
  const ref = useRef(null);

  const [showOverlay, setShowOverlay] = useState(true);

  const player = useMemo(() => {
    if (url) {
      return create(url, {
        fillAllSpace: true,
      });
    }
  }, [url]);

  useEffect(() => {
    if (player && ref.current) {
      player.attachToElement(ref.current);
      return () => {
        player.player.destroy();
      };
    }
  }, [player]);

  return (
    <div
      style={{
        paddingBottom: '56.25%',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      {showOverlay && (
        <PlayerOverlay
          previewImageUrl={getPreviewThumbnail(url)}
          previewImageAltText={previewImageAltText}
          onPlay={() => {
            setShowOverlay(false);
            player?.play!();
          }}
        />
      )}
      <div
        ref={ref}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          display: showOverlay ? 'none' : 'block',
        }}
      />
    </div>
  );
}

function getPreviewThumbnail(url: string) {
  return window.VideoGallerySDK.getVideoImage(url, {
    width: 1600,
    height: 900,
    previewIndex: 2,
  });
}
